import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import ReactPlayer from 'react-player'
import { useTranslations } from '../../utils/Text'
import Image from './Image'
import media from '../../utils/media'
import BtnAction from '../form/BtnAction'
import BtnClose from './BtnClose'

const BackgroundModal = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.92);
  height: 100vh;
  overflow-y: hidden;
`

const ContainerModal = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  max-width: calc(100vw - 71px);
  max-height: calc(100vh - 71px);
  z-index: 9998;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${media.mobileL`
    max-width: 100vw;
    max-height: 100vh;
  `}
`

const Header = styled.div`
  height: 45px;
  z-index: 9999;
  position: relative;
`

const ChildContainer = styled.div`
  width: 80%;
  height: 80%;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  ${media.laptopL`
    width: 100%;
    height: 100%;
    max-height: 690px;
  `}
  ${media.laptop`
    width: 100%;
    height: 100%;
    max-height: 590px;
  `}
  ${media.tablet`
    max-height: 409px;
  `}
  ${media.mobileL`
    top: 35%;
    max-height: 260px;
  `}
  ${media.mobileS`
    top: 35%;
    max-height: 197px;
  `}
  .react-player-modal {
    padding: 20px;
    margin: 0 auto;
  }
`

const Container = styled.div`
  width: 102vw;
  max-height: 760px;
  overflow: hidden;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-bottom: 100px;
  ${media.mobileL`
    margin-bottom: 40px;
  `}
`
/*eslint-disable */
const Overlay = styled.a`
  font-size: 0;
  position: absolute;
  height: 100%;
  max-height: 900px;
  width: 100%;
  top: 1%;
  left: 0;
  z-index: 999;
  @media (min-width: 1600px) {
    top: 10%;
  }
  @media (min-width: 1925px) {
    top: 22%;
  }
  ${props =>
    props.showVideo &&
    css`
      background-image: url(${props => props.playImg});
      background-repeat: no-repeat;
      background-position: center;
    `}
`

const PreVideo = styled.div`
  font-size: 0;
  ${props =>
    !props.showVideo &&
    css`
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.15);
      background-image: url(${props => props.playImg});
      background-repeat: no-repeat;
      background-position: center;
    `}
  ${media.mobileL`
    display: none;
  `}
`
/* eslint-enable */

const DesktopDiv = styled.div`
  position: relative;
  display: block;
  margin-top: -400px;
  margin-bottom: -60px;
  padding-top: 56.25%; /* 720 / 1280 = 0.5625 */
  ${media.laptopXL`
    margin-top: -180px;
  `}
  ${media.laptopL`
    margin-top: -80px;
  `}
  ${media.mobileL`
    display: none;
  `}

  .react-player {
    opacity: ${props => (!props.showVideo ? '0' : '1')};
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    .ytp-pause-overlay{
      display: none !important;
      opacity: 0 !important;
      height: 0 !important;
    }
  }
`
const MobileDiv = styled.div`
  display: none;
  ${media.mobileL`
    display: block;
    img {
      width: 100%;
    }
  `}
`
const Box = styled.div`
  display: none;
  ${media.mobileL`
    display: block;
    text-align: center;
    /* margin-bottom: 40px; */
    width: 100%;
    height: 100px;
    background-color: #fafafa;
    padding: 20px;
    .video-btn button {
      padding: 7px 35px;
      height: auto;
      width: auto;
    }
  `}
`

export default function VideoFullWidth({ config }) {
  const {
    imgDesktop,
    imgMobile,
    alt,
    maxHeight,
    youtube,
    optional,
    playImg,
    btnPlay,
  } = config

  const youtubeToShow = useTranslations(youtube, { optional })
  const imgDesktopToShow = useTranslations(imgDesktop, { optional })
  const imgMobileToShow = useTranslations(imgMobile, { optional })
  const playImgToShow = useTranslations(playImg, { optional })

  const [isVideoStart, setVideoStart] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [playVideo, setPlayVideo] = useState(true)
  const [windowWidth, setWindowWidth] = useState(window.inninnerWidth)

  const updateWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    updateWidth()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [windowWidth])

  useEffect(() => {
    if (isVideoStart && !showVideo) {
      setTimeout(function() {
        setShowVideo(true)
      }, 300)
    }
  }, [isVideoStart, showVideo])

  useEffect(() => {
    if (showModal) {
      setPlayVideo(false)
    } else {
      setPlayVideo(true)
    }
  }, [showModal, playVideo])

  useEffect(() => {
    if (showModal) {
      document.body.style.position = 'fixed'
      document.body.style.top = '0'
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.body.style.bottom = '0'
    } else {
      document.body.style.position = 'relative'
    }
  }, [showModal])

  return (
    <>
      {optional &&
      imgDesktopToShow === null &&
      imgMobileToShow === null &&
      youtubeToShow === null ? null : (
        <>
          {showModal && (
            <BackgroundModal>
              <ContainerModal>
                <Header>
                  <div className="header-btn-close">
                    <BtnClose
                      action={() => setShowModal()}
                      width="14"
                      height="14"
                      color="transparent"
                    />
                  </div>
                </Header>
                <ChildContainer>
                  <ReactPlayer
                    url={youtubeToShow}
                    className="react-player-modal"
                    controls
                    width="100%"
                    height="100%"
                    config={{
                      youtube: {
                        playerVars: {
                          showinfo: 1,
                          controls: 1,
                        },
                      },
                    }}
                  />
                </ChildContainer>
              </ContainerModal>
            </BackgroundModal>
          )}
          <Container className="main-cont-video">
            <PreVideo
              isVideoStart={isVideoStart}
              playImg={playImgToShow}
              showVideo={showVideo}
            >
              o
            </PreVideo>
            <DesktopDiv
              maxHeight={maxHeight}
              showVideo={showVideo}
              onClick={() => setShowModal(true)}
            >
              <Overlay
                playImg={playImgToShow}
                showVideo={showVideo}
                onClick={() => setShowModal(true)}
              >
                o
              </Overlay>
              {windowWidth > '425' && (
                <ReactPlayer
                  url={youtubeToShow}
                  className="react-player"
                  playing={playVideo}
                  loop
                  controls={false}
                  volume={0}
                  width="100%"
                  height="100%"
                  config={{
                    youtube: {
                      playerVars: {
                        showinfo: 0,
                        controls: 0,
                        ecver: 0,
                        rel: 0,
                      },
                    },
                  }}
                  onStart={() => setVideoStart(true)}
                  onError={() => setShowVideo(false)}
                />
              )}
              {/* </a> */}
            </DesktopDiv>
            <MobileDiv maxHeight={maxHeight}>
              <Image
                src={imgMobileToShow}
                alt={alt}
                classNameImage="img-fluid w-100"
              />
              <Box>
                <BtnAction
                  btn={btnPlay}
                  action={() => setShowModal(true)}
                  className="video-btn"
                />
              </Box>
            </MobileDiv>
          </Container>
        </>
      )}
    </>
  )
}
